import styles from './IdentityVerification.module.css';
import { motion } from 'framer-motion';
import { ShieldX } from 'lucide-react';
import { Link } from 'react-router-dom';

const IDVDeclined = () => {
  return (
    <motion.main
      className={`${styles.main} ${styles.centeredMain}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <ShieldX stroke='#f1416c' size={60} className={styles.successImg} />

      <p className={`${styles.successText} text-[--text-main]`}>Verification declined</p>

      <p className={styles.successPara}>
        Your identity verification has been <strong>declined</strong>. This means we were unable to
        verify your details at this time. <br />
        Please contact our support team to review or retry the process.
      </p>

      <div className={styles.buttonsWrap}>
        <Link
          to='mailto:support@tenantpay.com'
          className={`submitBtn ${styles.successBtn} w-full text-center hover:text-[#fff]`}
        >
          Contact support
        </Link>
      </div>
    </motion.main>
  );
};

export default IDVDeclined;
